import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/about-us-section-two-1.png";
import SectionTwoImageMobile from "../../Assets/Images/testimonials-img.png";
import AmericaFidImage from "../../Assets/Images/american-fidelity-white-logo.svg";
import AmericaFidRedImage from "../../Assets/Images/american-fidelity-testimonial-logo.svg";

const Testimonials = () => {
  return (
    <>
      <div className="flex-1">
        <div className="my-12 lg:hidden flex -ml-4 md:max-w-[600px] md:mx-auto">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-32 max-w-[417px] reveal-up  lg:pl-0 px-4">
        <img
          src={AmericaFidImage}
          className="mb-6 lg:block hidden"
          alt="iambest-logo"
        />
        <img
          src={AmericaFidRedImage}
          className="mb-6 lg:hidden block"
          alt="iambest-logo"
        />
        <p className="text-[14px] mb-2 text-justify lg:text-white text-black">
          "I am very happy to know that there is an insurance company that can
          take care of us and our financial needs. Thank you for your help!”
        </p>
        <button className="text-[#00363C] font-bold bg-white border text-[14px] border-[#0D4248] border-solid rounded-full text-sm px-5 text-center mb-4 gotofaqbtn hover:bg-[#eeecf3] hidden lg:block">
          Learn more
        </button>
      </div>
    </>
  );
};

export default Testimonials;
